// /src/utils/ctaHref.js
// import { useI18n } from 'vue-i18n'
// import { useRoute } from 'vue-router'

// export function useCtaHref() {
//   const { t } = useI18n()
//   const route = useRoute()

//   function ctaHref(overridePath) {
//     const origin = window.location?.origin || ''
//     const locale = route.params.locale || 'en'
//     const section = 'business-plan'

//     // allow explicit override OR pull from i18n (mission first, then foreword)
//     const raw =
//       overridePath ??
//       (t('mission.cta.href', '', { default: '' }) ||
//         t('foreword.cta.href', '', { default: '' }))

//     const path = String(raw || '').replace(/^\/+/, '')
//     const url = [origin, locale, section, path].filter(Boolean).join('/')
//     return url.replace(/([^:]\/)\/+/g, '$1')
//   }

//   return { ctaHref }
// }

// useCtaHref.js
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

// Helper: infer your nsKey the same way ThemePopulator does
function inferNsKey(route) {
  return (
    route?.meta?.ns ||
    route?.path?.split('/').pop()?.split('-')[0] ||
    ''
  )
}

export function createCtaHref({ t, route, nsKey }) {
  return function ctaHref(overridePath) {
    const origin =
      typeof window !== 'undefined' && window.location?.origin
        ? window.location.origin
        : ''
    const locale = route?.params?.locale || 'en'

    // 1) explicit override wins
    // 2) otherwise require a namespaced key
    const raw = overridePath ?? t?.(`${nsKey}.nextLinkSlug`) ?? ''

    // If empty/missing → go to locale home (no fallbacks)
    if (!raw) return [origin, locale, ''].filter(Boolean).join('/')

    // Absolute URLs pass through
    if (/^https?:\/\//i.test(raw)) return raw

    // Build locale-aware internal URL
    const section = 'business-plan'
    const path = String(raw).replace(/^\/+/, '')
    const url = [origin, locale, section, path].filter(Boolean).join('/')
    return url.replace(/([^:]\/)\/+/g, '$1')
  }
}

/**
 * Backwards-compatible hook.
 * - Old usage: const { ctaHref } = useCtaHref()   // still works
 * - New usage: const { ctaHref } = useCtaHref(nsKey)
 */
export function useCtaHref(nsKeyOptional) {
  const { t } = useI18n()
  const route = useRoute()
  const nsKey = nsKeyOptional ?? inferNsKey(route)
  const ctaHref = createCtaHref({ t, route, nsKey })
  return { ctaHref }
}